import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { RightCoolArrow, TriggerImageOne, TriggerImageTwo } from '../../../../assets/images';
import { WorkFlowActionContext, WorkFlowContext } from '../../../../utils/context';
import { getTriggerResponse, postActionResponse } from '../services';
import makeToast from '../../../../components/toaster';
import { LoaderOverlay } from '../../../../components';
import {
  ListeningText,
  RenderSchedulerContent,
  RenderWebhookContent,
  RenderWebhookContentTwo,
  successFulltext,
  testAgainText,
  TriggerRes,
  WebhookApiResponse,
  WebhookApiText,
} from '../data/constants';
import {
  ExecutionList,
  ExecutionRecord,
  testTabProps,
  WorkflowActionTypeStorage,
} from '../automator.props';

function Test({
  selectedNode,
  triggerId,
  actionId,
  setOpenPanel,
  testComplete,
  setTestComplete,
  setLogout,
  disableMode,
}: testTabProps) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [storedResponse, setStoredResponse] = useState<ExecutionList>([]);
  const triggerType = selectedNode?.data?.trigger_type || '';
  const { workFlowData } = useContext(WorkFlowContext);
  const { workFlowActionData, setWorkFlowActionData } = useContext(WorkFlowActionContext);
  const [loader, setLoader] = useState<boolean>(false);
  const [reRenderTestResponse, setReRenderTestResponse] = useState<boolean>(false);
  const [buttonText, setButtonText] = useState('Copy');
  const { projectId } = useParams();

  const savedValue = localStorage?.getItem('workFlowData');
  const parsedSavedValue = JSON.parse(savedValue!);

  const savedResponse = localStorage.getItem('triggerResponse');
  useEffect(() => {
    if (savedResponse) {
      setStoredResponse(JSON.parse(savedResponse));
    }
  }, [savedResponse && JSON.parse(savedResponse)?.length, reRenderTestResponse]);

  const testTabEnabled =
    selectedNode?.data?.node_type === 'trigger'
      ? JSON.parse(savedValue!)?.trigger?.isTestTabCompleted
      : workFlowActionData?.isTestTabCompleted;

  const renderSchedulerContent = () => (
    <div className="my-4">
      <h1 className="text-2xl font-bold">{successFulltext}</h1>
      <p className="text-sm text-[#828282]">{RenderSchedulerContent}</p>
    </div>
  );

  const instance = `${window.location.protocol}//${window.location.host}`;
  const webhookURL = `${instance}/webhook/${
    workFlowData?.workflow_id ||
    JSON.parse(localStorage.getItem('workFlowData') || '{}')?.trigger?.workflow_id
  }`;

  const handleCopy = () => {
    navigator.clipboard
      .writeText(webhookURL?.replace('.grazitti.com', '-llm.grazitti.com'))
      .then(() => {
        setButtonText('Copied');
        setTimeout(() => setButtonText('Copy'), 2000); // Reset to "Copy" after 2 seconds
      })
      .catch((err) => {
        throw err;
      });
  };

  const renderWebhookContent = () => (
    <>
      <div className="my-2">
        <h1 className="text-2xl font-bold">{WebhookApiText}</h1>
        <p className="text-sm text-[#828282]">{RenderWebhookContent}</p>
      </div>
      <div className="my-2 relative w-full">
        <input
          className="w-full rounded-lg border-[#0828B7] py-3 pr-12 pl-4"
          value={webhookURL?.replace('.grazitti.com', '-llm.grazitti.com')}
          disabled
        />
        <button
          type="button"
          onClick={handleCopy}
          className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-[#0828B7] text-white px-3 py-1 rounded-lg focus:outline-none"
        >
          <span className="text-sm">{buttonText}</span>
        </button>
      </div>
      <div className="images flex gap-3">
        <img src={TriggerImageOne} alt="Trigger 1" />
        <img src={RightCoolArrow} alt="Arrow" />
        <img src={TriggerImageTwo} alt="Trigger 2" />
      </div>
      <div className="my-2">
        <h1 className="text-2xl font-bold">{ListeningText}</h1>
        <p className="text-sm text-[#828282]">{RenderWebhookContentTwo}</p>
      </div>
      {storedResponse?.[0] ? (
        <div className="mb-4 text-sm text-green-600 font-medium">
          <h3>{TriggerRes}</h3>
          <pre className="bg-gray-100 p-2 rounded-md text-xs text-gray-800">
            {JSON.stringify(storedResponse?.[0]?.response, null, 2)}
          </pre>
        </div>
      ) : (
        <span className="block mb-2 text-md text-orange-400 font-medium">{WebhookApiResponse}</span>
      )}
    </>
  );

  const renderActionContent = () => (
    <>
      <div className="text-sm text-[#828282] my-2">
        To verify, your action is settled up correctly, please test your action.
      </div>
      {/* eslint-disable-next-line radix */}
      {selectedNode?.id && storedResponse?.[parseInt(selectedNode.id) - 1]?.response && (
        <div className="mb-4 text-sm text-green-600 font-medium">
          <h3>Stored Action Response:</h3>
          <pre className="bg-gray-100 p-2 rounded-md text-xs text-gray-800">
            {/* eslint-disable-next-line radix */}
            {JSON.stringify(storedResponse?.[parseInt(selectedNode?.id) - 1]?.response, null, 2)}
          </pre>
        </div>
      )}
    </>
  );

  const handleTestTrigger = () => {
    const dataWorkFlow = localStorage?.getItem('workFlowData');
    const parsedValue = dataWorkFlow ? JSON.parse(dataWorkFlow) : {};
    const x = storedResponse.length - 1;
    if (triggerType === 'Webhook API' || triggerType === 'Schedule') {
      if (testComplete || testTabEnabled) {
        setOpenPanel(false);
      } else if (triggerType === 'Webhook API') {
        setLoader(true);
        const data = {
          triggerId:
            triggerId ||
            JSON.parse(localStorage.getItem('workFlowData') || '{}')?.trigger?.trigger_id,
          workflow_id:
            workFlowData?.workflow_id ||
            JSON.parse(localStorage.getItem('workFlowData') || '{}')?.trigger?.workflow_id,
        };
        getTriggerResponse(data)
          .then((res) => {
            const triggerResData = res?.data;
            if (res?.status === 401) {
              setLogout(true);

              return;
            }
            if (triggerResData) {
              setLoader(false);
              localStorage.setItem(
                'triggerResponse',
                JSON.stringify([
                  {
                    response: triggerResData?.[0]?.last_response,
                    execution_id: triggerResData?.[0]?.execution_id,
                    previous_id: triggerResData?.[0]?.trigger_id,
                  },
                ]),
              );
              setStoredResponse((prev) => [
                ...(Array.isArray(prev) ? prev : []),
                {
                  response: triggerResData?.[0]?.last_response,
                  execution_id: triggerResData?.[0]?.execution_id,
                  previous_id: triggerResData?.[0]?.trigger_id,
                },
              ]);
              setWorkFlowActionData((prev) => ({
                ...prev,

                project_id: projectId,
                previous_id: triggerResData?.[0]?.trigger_id,
                prev_execution_id: triggerResData?.[0]?.execution_id,
              }));
              localStorage.setItem(
                'workFlowData',
                JSON.stringify({
                  ...parsedSavedValue,
                  trigger: {
                    ...parsedSavedValue.trigger,
                    isTestTabCompleted: true,
                  },
                }),
              );
              setTestComplete(true);
            }
          })
          .catch(() => {
            setLoader(false);
            makeToast('error', 'Something went wrong');
          });
      } else if (triggerType === 'Schedule') {
        localStorage.setItem(
          'workFlowData',
          JSON.stringify({
            ...parsedSavedValue,
            trigger: {
              ...parsedSavedValue.trigger,
              isTestTabCompleted: true,
            },
          }),
        );
        localStorage.setItem(
          'triggerResponse',
          JSON.stringify([
            {
              response: 'scheduler_data',
              execution_id: 'scheduler_data',
              previous_id: 'scheduler_data',
            },
          ]),
        );
        makeToast('success', 'Trigger created successfully!');
        setTestComplete(true);
        setOpenPanel(false);
      }
    } else if (
      // eslint-disable-next-line radix
      storedResponse?.[x]?.response ||
      storedResponse?.[0]?.execution_id === 'scheduler_data'
    ) {
      if (testComplete || testTabEnabled) {
        setOpenPanel(false);
      } else if (
        triggerType === 'Assistants' ||
        triggerType === 'Send Prompt' ||
        triggerType === 'send prompt' ||
        triggerType === 'API' ||
        triggerType === 'Send HTTP Request' ||
        triggerType === 'Gateways'
      ) {
        setLoader(true);
        const savedWorkFlowTest = localStorage?.getItem('workFlowData');
        const parsedSavedValueFlow = savedWorkFlowTest ? JSON.parse(savedWorkFlowTest) : {};
        const selectActionConfig = parsedSavedValueFlow?.actions?.findIndex(
          (item: WorkflowActionTypeStorage) =>
            /* eslint-disable-next-line eqeqeq */
            item.action_order == selectedNode?.id ||
            /* eslint-disable-next-line eqeqeq */
            (item.action_id && item.action_id == selectedNode?.data.unique_id),
        );
        const previousData =
          selectActionConfig === 0
            ? parsedSavedValueFlow?.trigger
            : parsedSavedValueFlow?.actions[selectActionConfig - 1];
        let data = {
          workflow_id: workFlowActionData?.workflow_id ?? 0,
          project_id: projectId ?? 0,
          action_id: actionId || selectedNode?.data?.unique_id,
          previous_node_id: '',
          previous_node_type: '',
        };
        if (selectActionConfig === 0) {
          data = {
            ...data,
            previous_node_id: previousData?.id || previousData?.trigger_id,
            previous_node_type: 'trigger',
          };
        } else {
          data = {
            ...data,
            previous_node_id: previousData?.id || previousData?.action_id,
            previous_node_type: 'action',
          };
        }
        postActionResponse(data)
          .then((res) => {
            if (res.status === 200) {
              const actionData = res.data.data;
              const selectActionConfigIndex = parsedValue?.actions?.findIndex(
                (item: WorkflowActionTypeStorage) =>
                  /* eslint-disable-next-line eqeqeq */
                  item.action_order == selectedNode?.id ||
                  /* eslint-disable-next-line eqeqeq */
                  (item.action_id && item.action_id == selectedNode?.data.unique_id),
              );
              const updatedActions = [...(parsedValue?.actions ?? [])];
              updatedActions[selectActionConfigIndex] = {
                ...workFlowActionData,
                action_id: actionId || selectedNode?.data?.unique_id,
                isTestTabCompleted: true,
              };
              localStorage.setItem(
                'workFlowData',
                JSON.stringify({
                  ...parsedValue,
                  actions: updatedActions,
                }),
              );
              const savedData = localStorage?.getItem('triggerResponse');
              const parsedData = savedData ? JSON.parse(savedData) : [];
              const index = parsedData.findIndex(
                (item: ExecutionRecord) => item.previous_id === actionData.previous_id,
              );
              if (index !== -1) {
                // If found, update the existing object
                parsedData[index] = actionData;
              } else {
                // If not found, add a new entry
                parsedData.push(actionData);
              }
              localStorage.setItem('triggerResponse', JSON.stringify(parsedData));
              setLoader(false);
              setTestComplete(true);
            } else if (res?.status === 401) {
              setLogout(true);
            }
          })
          .catch((err) => {
            setLoader(false);
            makeToast(
              'error',
              triggerType === 'Gateways' ? err?.response?.data?.message : 'Something went wrong',
            );
          });
      }
    } else {
      makeToast('warning', 'Please Complete the previous step to move ahead!');
    }
  };

  const handleReTestTrigger = () => {
    const savedResTestValue = localStorage?.getItem('workFlowData');
    const parsedValue = savedResTestValue ? JSON.parse(savedResTestValue) : {};
    const x = storedResponse.length - 1;
    if (triggerType === 'Webhook API' || triggerType === 'Schedule') {
      if (triggerType === 'Webhook API') {
        setLoader(true);
        const data = {
          triggerId:
            triggerId ||
            JSON.parse(localStorage.getItem('workFlowData') || '{}')?.trigger?.trigger_id,
          workflow_id:
            workFlowData?.workflow_id ||
            JSON.parse(localStorage.getItem('workFlowData') || '{}')?.trigger?.workflow_id,
        };
        getTriggerResponse(data)
          .then((res) => {
            const retestData = res?.data;
            if (res?.status === 401) {
              setLogout(true);
              return;
            }
            if (retestData) {
              setLoader(false);
              localStorage.setItem(
                'triggerResponse',
                JSON.stringify([
                  {
                    response: retestData?.[0]?.last_response,
                    execution_id: retestData?.[0]?.execution_id,
                    previous_id: retestData?.[0]?.trigger_id,
                  },
                ]),
              );
              setStoredResponse((prev) => [
                ...(Array.isArray(prev) ? prev : []),
                {
                  response: retestData?.[0]?.last_response,
                  execution_id: retestData?.[0]?.execution_id,
                  previous_id: retestData?.[0]?.trigger_id,
                },
              ]);
              setReRenderTestResponse((prev) => !prev);
              setWorkFlowActionData((prev) => ({
                ...prev,
                project_id: projectId,
                previous_id: retestData?.[0]?.trigger_id,
                prev_execution_id: retestData?.[0]?.execution_id,
              }));
              localStorage.setItem(
                'workFlowData',
                JSON.stringify({
                  ...parsedSavedValue,
                  trigger: {
                    ...parsedSavedValue.trigger,
                    isTestTabCompleted: true,
                  },
                }),
              );
              makeToast('success', 'Trigger Tested Again Successfully!');
            }
          })
          .catch(() => {
            setLoader(false);
            makeToast('error', 'Something went wrong');
          });
      } else if (triggerType === 'Schedule') {
        localStorage.setItem(
          'workFlowData',
          JSON.stringify({
            ...parsedSavedValue,
            trigger: {
              ...parsedSavedValue.trigger,
              isTestTabCompleted: true,
            },
          }),
        );
        localStorage.setItem(
          'triggerResponse',
          JSON.stringify([
            {
              response: 'scheduler_data',
              execution_id: 'scheduler_data',
              previous_id: 'scheduler_data',
            },
          ]),
        );
        makeToast('success', 'Trigger created successfully!');
      }
    } else if (
      // eslint-disable-next-line radix
      storedResponse?.[x]?.response ||
      storedResponse?.[0]?.execution_id === 'scheduler_data'
    ) {
      if (
        triggerType === 'Assistants' ||
        triggerType === 'Send Prompt' ||
        triggerType === 'send prompt' ||
        triggerType === 'API' ||
        triggerType === 'Send HTTP Request' ||
        triggerType === 'Gateways'
      ) {
        setLoader(true);
        const savedValueInRetestAction = localStorage?.getItem('workFlowData');
        const parsedSavedReTestValue = savedValueInRetestAction
          ? JSON.parse(savedValueInRetestAction)
          : {};
        const selectActionConfig = parsedSavedReTestValue?.actions?.findIndex(
          (item: WorkflowActionTypeStorage) =>
            /* eslint-disable-next-line eqeqeq */
            item.action_order == selectedNode?.id ||
            /* eslint-disable-next-line eqeqeq */
            (item.action_id && item.action_id == selectedNode?.data.unique_id),
        );
        const previousData =
          selectActionConfig === 0
            ? parsedSavedReTestValue?.trigger
            : parsedSavedReTestValue?.actions[selectActionConfig - 1];
        let data = {
          workflow_id: workFlowActionData?.workflow_id ?? 0,
          project_id: projectId ?? 0,
          action_id: actionId || selectedNode?.data?.unique_id,
          previous_node_id: '',
          previous_node_type: '',
        };
        if (selectActionConfig === 0) {
          data = {
            ...data,
            previous_node_id: previousData?.id || previousData?.trigger_id,
            previous_node_type: 'trigger',
          };
        } else {
          data = {
            ...data,
            previous_node_id: previousData?.id || previousData?.action_id,
            previous_node_type: 'action',
          };
        }
        postActionResponse(data)
          .then((res) => {
            if (res.status === 200) {
              const actionData = res.data.data;
              const selectActionConfigIndex = parsedValue?.actions?.findIndex(
                (item: WorkflowActionTypeStorage) =>
                  /* eslint-disable-next-line eqeqeq */
                  item?.action_order == selectedNode?.id ||
                  /* eslint-disable-next-line eqeqeq */
                  (item.action_id && item.action_id == selectedNode?.data?.unique_id),
              );
              const updatedActions = [...(parsedValue?.actions ?? [])];
              updatedActions[selectActionConfigIndex] = {
                ...workFlowActionData,
                action_id: actionId || selectedNode?.data?.unique_id,
                isTestTabCompleted: true,
              };
              localStorage.setItem(
                'workFlowData',
                JSON.stringify({
                  ...parsedValue, // Preserve existing data
                  actions: updatedActions,
                }),
              );
              const savedData = localStorage?.getItem('triggerResponse');
              const parsedData = savedData ? JSON.parse(savedData) : [];
              const index = parsedData.findIndex(
                (item: ExecutionRecord) => item.previous_id === actionData.previous_id,
              );

              if (index !== -1) {
                parsedData[index] = actionData;
              } else {
                parsedData.push(actionData);
              }
              setStoredResponse((prev: ExecutionList) => [...prev, actionData]);
              setReRenderTestResponse((prev) => !prev);
              localStorage.setItem('triggerResponse', JSON.stringify(parsedData));
              setLoader(false);
              makeToast('success', 'Action Tested Again Successfully!');
            } else if (res?.status === 401) {
              setLogout(true);
            }
          })
          .catch((err) => {
            setLoader(false);
            makeToast(
              'error',
              triggerType === 'Gateways' ? err?.response?.data?.message : 'Something went wrong',
            );
          });
      }
    } else {
      makeToast('warning', 'Please Complete the previous step to move ahead!');
    }
  };

  const getButtonText = () => {
    if (testComplete || testTabEnabled) return 'Continue';
    const testActions = [
      'API',
      'Send HTTP Request',
      'Gateways',
      'Assistants',
      'Send Prompt',
      'send prompt',
    ];

    if (testActions.includes(triggerType)) return 'Test Action';
    if (triggerType === 'Schedule') return 'Save';

    return 'Test Trigger';
  };

  return (
    <div>
      <div className="images flex gap-3">
        <img src={TriggerImageOne} alt="trigger-image" />
        <img src={RightCoolArrow} alt="right-arrow" />
        <img src={TriggerImageTwo} alt="trigger-two" />
      </div>
      <div>
        {(() => {
          switch (triggerType) {
            case 'Schedule':
              return renderSchedulerContent();
            case 'Webhook API':
              return renderWebhookContent();
            case 'Assistants':
            case 'Send Prompt':
            case 'send prompt':
            case 'API':
            case 'Gateways':
            case 'Send HTTP Request':
              return renderActionContent();
            default:
              return <div>No content available for this trigger type.</div>;
          }
        })()}
      </div>

      <div className="flex space-x-1">
        {(triggerType === 'Webhook API' ||
          triggerType === 'API' ||
          triggerType === 'Send HTTP Request' ||
          triggerType === 'Gateways' ||
          triggerType === 'Assistants' ||
          triggerType === 'Send Prompt' ||
          triggerType === 'send prompt') &&
          (testComplete || testTabEnabled) && (
            <button
              type="button"
              className="w-full py-2 rounded-lg bg-[#122961]"
              onClick={() => handleReTestTrigger()}
            >
              <span className="text-white">{testAgainText}</span>
            </button>
          )}

        <button
          type="button"
          className="w-full py-2 rounded-lg bg-[#122961]"
          disabled={disableMode}
          onClick={handleTestTrigger}
        >
          <span className="text-white">{getButtonText()}</span>
        </button>
      </div>
      {loader && <LoaderOverlay />}
    </div>
  );
}

export default Test;
